export const VISIBILITY_MAINTENANCE = false;
export const PRE_MAINTENANCE = false;
export const ExceptionalReferralLink = [
    "https://app.refactor.academy/register?referralCode=Reema_SHG8CB",
];
export const BotSuggestedAnswer = [
    {
        ans: "I don't know the answer",
    },
];
export const LastTwoMinutesTagLine = [
    "The test is nearing its end, give it your all for two more minutes!",
    "The final countdown: just 120 seconds to go!",
    "In the blink of an eye, only two minutes left!",
    "Time is slipping away, seize the next two minutes!",
    "The clock is ticking, embrace the last 120 seconds!",
    "Two minutes separate you from the finish line, give your best!",
    "The last two minutes are here, leave a lasting impression!",
    "Only a brief window remains, make it count in the next two minutes!",
    "Two minutes left to shine, show your true potential!",
    "The final stretch is upon us, use these two minutes wisely!",
];
export const NoShowStageStatusForTenant = ["datavalley"];
export const SampleAudioTracks = {
    fr: `I am looking forward to taking this digital interview`,
    en: `I am looking forward to taking this digital interview`,
    hi: `इस डिजिटल इंटरव्यू में भाग लेने के लिए मैं तैयार हूँ। <br /> I am looking forward to taking this digital interview`,
};
export const SampleAudioTracksAiCoach = {
    fr: `I am looking forward to taking this digital assessment`,
    en: `I am looking forward to taking this digital assessment`,
    hi: `इस डिजिटल इंटरव्यू में भाग लेने के लिए मैं तैयार हूँ। <br /> I am looking forward to taking this digital interview`,
};
export const RecordAudioInstruction = {
    fr: `Please read the text provided below in a clear and audible manner.`,
    en: `Please read the text provided below in a clear and audible manner.`,
    hi: `कृपया नीचे दिए गए पाठ को स्पष्ट और सुनाई देने वाले ढंग से पढ़ें। <br /> Please read the text provided below in a clear and audible manner.`,
};
